import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c35401b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "base-form-inline-entry-description"
}

import BaseTypography from "@/ui-library/base-typography/base-typography.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'base-form-inline-entry-description',
  props: {
  description: {
    type: String,
    default: "",
  },
  errorMessage: {
    type: String,
    default: "",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.description || __props.errorMessage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.errorMessage)
          ? (_openBlock(), _createBlock(BaseTypography, {
              key: 0,
              error: "",
              caption: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.errorMessage), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(BaseTypography, { caption: "" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.description), 1)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})